<template lang="pug">
.input-pulldown
  .input-pulldown__text-before(v-if='beforeText') {{ beforeText }}
  .input-pulldown__input
    select-base.input-pulldown__input__select(@input='updateValue')
      option-base.input-pulldown__input__select__option(
        v-for='(item, index) in items',
        :value='item.value',
        :key='index',
        :selected='item.value === value'
      ) {{ item.label }}
  .input-pulldown__text-after(v-if='afterText') {{ afterText }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import SelectBase from '@/components/atoms/SelectBase.vue'
import OptionBase from '@/components/atoms/OptionBase.vue'
import { InputItem } from '@/models/inputItem'

/**
 * プルダウン選択
 */
@Component({
  components: {
    SelectBase,
    OptionBase,
  },
})
export default class InputPulldown extends Vue {
  // 選択肢情報
  @Prop()
  items!: InputItem[]

  // 選択値
  @Prop()
  value!: string

  // 前方テキスト
  @Prop()
  beforeText?: string

  // 後方テキスト
  @Prop()
  afterText?: string

  private updateValue(value: string): void {
    this.$emit('input', value)
  }
}
</script>

<style lang="stylus" scoped>
.input-pulldown
  display flex
  flex-wrap wrap
  align-items center
  &__input
    position relative
    margin-right 10px
    &__select
      width 180px
      height var(--input-height-default)
      appearance none
      outline none
      padding 0 35px 0 15px
      border 1px solid var(--color-default__input-border)
      border-radius 4px

    &::before
      position absolute
      top 50%
      right 10px
      width 0
      height 0
      padding 0
      content ''
      border-left 6px solid transparent
      border-right 6px solid transparent
      border-top 6px solid var(--color-default__input-border)
      pointer-events none

  &__text-before
    margin-right 10px
</style>
